import React from 'react';

function ResumeContainer(){
  return (
    <iframe src="./ChayaGreismanResume.pdf" width="100%" height={window.screen.height - window.screen.height/5.5} title='resume-iframe'></iframe>
  );
}

export default ResumeContainer;